import type { AppRegion } from '@/entities/region'
import { useAuthStore } from './auth.store'

export interface RealtimeAuthSession {
  token: string
  region: AppRegion
}

export function useIsRealtimeAuthSessionAvailable(): boolean {
  return useAuthStore(state => state.isAuthenticated())
}

export function getRealtimeAuthSession(): RealtimeAuthSession | null {
  const { token, region, isAuthenticated } = useAuthStore.getState()

  if (!isAuthenticated() || !token || !region) {
    return null
  }

  return { token, region }
}
